import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  /** Icon (z. B. Lucide), groß und dezent über dem Titel. */
  icon?: ReactNode;
  /** Call-to-Action, z. B. Button „Ersten Kontakt anlegen". */
  action?: ReactNode;
}

export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <div className="au-empty">
      {icon !== undefined ? (
        <div className="au-empty__icon" aria-hidden>
          {icon}
        </div>
      ) : null}
      <p className="au-empty__title">{title}</p>
      {description !== undefined ? <p className="au-empty__text">{description}</p> : null}
      {action !== undefined ? <div className="au-empty__action">{action}</div> : null}
    </div>
  );
}
